import request from '@/utils/requests';

const getters = {
  getEnvironmentalImpactData: (state) => state.environmentalImpactData,
  getEnvironmentalImpactLoading: (state) => state.environmentalImpactLoading,
  getEnvironmentalImpactError: (state) => state.environmentalImpactError,
  getDonationTagsBreakdownData: (state) => state.donationTagsBreakdownData,
  getDonationTagsBreakdownLoading: (state) => state.donationTagsBreakdownLoading,
  getDonationTagsBreakdownError: (state) => state.donationTagsBreakdownError,
  getDonationMetricsData: (state) => state.donationMetricsData,
  getDonationMetricsLoading: (state) => state.donationMetricsLoading,
  getDonationMetricsError: (state) => state.donationMetricsError,
  getDonationsFeedData: (state) => state.donationsFeedData,
  getDonationsFeedLoading: (state) => state.donationsFeedLoading,
  getDonationsFeedError: (state) => state.donationsFeedError,
  getTopDonorsData: (state) => state.topDonorsData,
  getTopDonorsLoading: (state) => state.topDonorsLoading,
  getTopDonorsError: (state) => state.topDonorsError,
  getCompaniesData: (state) => state.companiesData,
  getCompaniesLoading: (state) => state.companiesLoading,
  getCompaniesError: (state) => state.companiesError,
  getDonorDonationsData: (state) => state.donorDonationsData,
  getDonorDonationsLoading: (state) => state.donorDonationsLoading,
  getDonorDonationsError: (state) => state.donorDonationsError,
  getVolunteersData: (state) => state.volunteersData,
  getVolunteersLoading: (state) => state.volunteersLoading,
  getVolunteersError: (state) => state.volunteersError,
  getMarketplaceLocationsData: (state) => state.marketplaceLocationsData,
  getMarketplaceLocationsLoading: (state) => state.marketplaceLocationsLoading,
  getMarketplaceLocationsError: (state) => state.marketplaceLocationsError,

};

const mutations = {
  SET_ENVIRONMENTAL_IMPACT_DATA: (state, data) => {
    state.environmentalImpactData = data;
  },
  SET_ENVIRONMENTAL_IMPACT_LOADING: (state, loading) => {
    state.environmentalImpactLoading = loading;
  },
  SET_ENVIRONMENTAL_IMPACT_ERROR: (state, error) => {
    state.environmentalImpactError = error;
  },
  SET_DONATION_TAGS_BREAKDOWN_DATA: (state, data) => {
    state.donationTagsBreakdownData = data;
  },
  SET_DONATION_TAGS_BREAKDOWN_LOADING: (state, loading) => {
    state.donationTagsBreakdownLoading = loading;
  },
  SET_DONATION_TAGS_BREAKDOWN_ERROR: (state, error) => {
    state.donationTagsBreakdownError = error;
  },
  SET_DONATION_METRICS_DATA: (state, data) => {
    state.donationMetricsData = data;
  },
  SET_DONATION_METRICS_LOADING: (state, loading) => {
    state.donationMetricsLoading = loading;
  },
  SET_DONATION_METRICS_ERROR: (state, error) => {
    state.donationMetricsError = error;
  },
  SET_DONATIONS_FEED_DATA: (state, data) => {
    state.donationsFeedData = data;
  },
  APPEND_DONATIONS_FEED_DATA: (state, data) => {
    if (state.donationsFeedData) {
      state.donationsFeedData = [...state.donationsFeedData, ...data];
    } else {
      state.donationsFeedData = data;
    }
  },
  SET_DONATIONS_FEED_LOADING: (state, loading) => {
    state.donationsFeedLoading = loading;
  },
  SET_DONATIONS_FEED_ERROR: (state, error) => {
    state.donationsFeedError = error;
  },
  SET_TOP_DONORS_DATA: (state, data) => {
    state.topDonorsData = data;
  },
  SET_TOP_DONORS_LOADING: (state, loading) => {
    state.topDonorsLoading = loading;
  },
  SET_TOP_DONORS_ERROR: (state, error) => {
    state.topDonorsError = error;
  },
  SET_COMPANIES_DATA: (state, data) => {
    state.companiesData = data;
  },
  SET_COMPANIES_LOADING: (state, loading) => {
    state.companiesLoading = loading;
  },
  SET_COMPANIES_ERROR: (state, error) => {
    state.companiesError = error;
  },
  SET_DONOR_DONATIONS_DATA: (state, data) => {
    state.donorDonationsData = data;
  },
  SET_DONOR_DONATIONS_LOADING: (state, loading) => {
    state.donorDonationsLoading = loading;
  },
  SET_DONOR_DONATIONS_ERROR: (state, error) => {
    state.donorDonationsError = error;
  },
  SET_VOLUNTEERS_DATA: (state, data) => {
    state.volunteersData = data;
  },
  SET_VOLUNTEERS_LOADING: (state, loading) => {
    state.volunteersLoading = loading;
  },
  SET_VOLUNTEERS_ERROR: (state, error) => {
    state.volunteersError = error;
  },
  SET_MARKETPLACE_LOCATIONS_DATA: (state, data) => {
    state.marketplaceLocationsData = data;
  },
  SET_MARKETPLACE_LOCATIONS_LOADING: (state, loading) => {
    state.marketplaceLocationsLoading = loading;
  },
  SET_MARKETPLACE_LOCATIONS_ERROR: (state, error) => {
    state.marketplaceLocationsError = error;
  },

};

const actions = {
  async fetchEnvironmentalImpactData({ commit, rootGetters }, companyId = null) {
    try {
      commit('SET_ENVIRONMENTAL_IMPACT_LOADING', true);
      commit('SET_ENVIRONMENTAL_IMPACT_ERROR', null);

      const queryParams = {};
      if (companyId) {
        queryParams.company_id = companyId;
      }

      const response = await request(
        'GET',
        'api/donations-dashboard/environmental-impact',
        rootGetters['auth/getToken'],
        {},
        queryParams
      );

      if (response.data && response.data.success) {
        commit('SET_ENVIRONMENTAL_IMPACT_DATA', response.data.data);
      } else {
        throw new Error('Failed to fetch environmental impact data');
      }
    } catch (error) {
      console.error('Error fetching environmental impact data:', error);
      commit('SET_ENVIRONMENTAL_IMPACT_ERROR', error.message || 'Failed to fetch environmental impact data');
      throw error;
    } finally {
      commit('SET_ENVIRONMENTAL_IMPACT_LOADING', false);
    }
  },

  async fetchDonationTagsBreakdownData({ commit, rootGetters }, companyId = null) {
    try {
      commit('SET_DONATION_TAGS_BREAKDOWN_LOADING', true);
      commit('SET_DONATION_TAGS_BREAKDOWN_ERROR', null);

      const queryParams = {};
      if (companyId) {
        queryParams.company_id = companyId;
      }

      const response = await request(
        'GET',
        'api/donations-dashboard/donation-tags-breakdown',
        rootGetters['auth/getToken'],
        {},
        queryParams
      );

      if (response.data && response.data.success) {
        commit('SET_DONATION_TAGS_BREAKDOWN_DATA', response.data.data);
      } else {
        throw new Error('Failed to fetch donation tags breakdown data');
      }
    } catch (error) {
      console.error('Error fetching donation tags breakdown data:', error);
      commit('SET_DONATION_TAGS_BREAKDOWN_ERROR', error.message || 'Failed to fetch donation tags breakdown data');
      throw error;
    } finally {
      commit('SET_DONATION_TAGS_BREAKDOWN_LOADING', false);
    }
  },

  async fetchDonationMetricsData({ commit, rootGetters }, companyId = null) {
    try {
      commit('SET_DONATION_METRICS_LOADING', true);
      commit('SET_DONATION_METRICS_ERROR', null);

      const queryParams = {};
      if (companyId) {
        queryParams.company_id = companyId;
      }

      const response = await request(
        'GET',
        'api/donations-dashboard/donation-metrics',
        rootGetters['auth/getToken'],
        {},
        queryParams
      );

      if (response.data && response.data.success) {
        commit('SET_DONATION_METRICS_DATA', response.data.data);
      } else {
        throw new Error('Failed to fetch donation metrics data');
      }
    } catch (error) {
      console.error('Error fetching donation metrics data:', error);
      commit('SET_DONATION_METRICS_ERROR', error.message || 'Failed to fetch donation metrics data');
      throw error;
    } finally {
      commit('SET_DONATION_METRICS_LOADING', false);
    }
  },

  async fetchDonationsFeedData({ commit, rootGetters }, options = {}) {
    try {
      const { page = 1, limit = 10, append = false } =
        typeof options === 'object' && options !== null ? options : {};

      // Only show loading spinner on initial load, not when appending
      if (!append) {
        commit('SET_DONATIONS_FEED_LOADING', true);
      }
      commit('SET_DONATIONS_FEED_ERROR', null);

      const queryParams = { page, limit };

      const response = await request(
        'GET',
        'api/donations-dashboard/donations-feed',
        rootGetters['auth/getToken'],
        {},
        queryParams
      );

      if (response.data && response.data.success) {
        const responseData = response.data.data;

        // Handle both paginated and non-paginated responses
        const donations = responseData.donations || responseData;
        const pagination = responseData.pagination || null;

        if (append) {
          commit('APPEND_DONATIONS_FEED_DATA', donations);
        } else {
          commit('SET_DONATIONS_FEED_DATA', donations);
        }

        return { pagination };
      }
        throw new Error('Failed to fetch donations feed data');
      
    } catch (error) {
      console.error('Error fetching donations feed data:', error);
      commit('SET_DONATIONS_FEED_ERROR', error.message || 'Failed to fetch donations feed data');
      throw error;
    } finally {
      commit('SET_DONATIONS_FEED_LOADING', false);
    }
  },

  async fetchTopDonorsData({ commit, state, rootGetters }, options = {}) {
    try {
      // Handle both old format (companyId) and new format ({ page, limit, append, companyId })
      const { page = 1, limit = 10, append = false, companyId = null } =
        typeof options === 'object' && options !== null ? options : { companyId: options };

      // Only show loading spinner on initial load, not when appending
      if (!append) {
        commit('SET_TOP_DONORS_LOADING', true);
      }
      commit('SET_TOP_DONORS_ERROR', null);

      const queryParams = { page, limit };
      if (companyId) {
        queryParams.company_id = companyId;
      }

      const response = await request(
        'GET',
        'api/donations-dashboard/top-donors',
        rootGetters['auth/getToken'],
        {},
        queryParams
      );

      if (response.data && response.data.success) {
        const { donors, pagination } = response.data.data;

        if (append && state.topDonorsData) {
          // Append new donors to existing list
          commit('SET_TOP_DONORS_DATA', [...state.topDonorsData, ...donors]);
        } else {
          // Replace with new data
          commit('SET_TOP_DONORS_DATA', donors);
        }

        return { pagination };
      }
      throw new Error('Failed to fetch top donors data');
    } catch (error) {
      console.error('Error fetching top donors data:', error);
      commit('SET_TOP_DONORS_ERROR', error.message || 'Failed to fetch top donors data');
      throw error;
    } finally {
      commit('SET_TOP_DONORS_LOADING', false);
    }
  },

  async fetchCompaniesData({ commit, rootGetters }) {
    try {
      commit('SET_COMPANIES_LOADING', true);
      commit('SET_COMPANIES_ERROR', null);

      const response = await request(
        'GET',
        'api/companies',
        rootGetters['auth/getToken'],
        {},
        {}
      );

      if (response.data && response.data.items && Array.isArray(response.data.items)) {
        commit('SET_COMPANIES_DATA', response.data.items);
      } else {
        console.log('Unexpected API response structure:', response.data);
        throw new Error('Failed to fetch companies data - invalid response structure');
      }
    } catch (error) {
      console.error('Error fetching companies data:', error);
      commit('SET_COMPANIES_ERROR', error.message || 'Failed to fetch companies data');
      throw error;
    } finally {
      commit('SET_COMPANIES_LOADING', false);
    }
  },

  async fetchDonorDonationsData({ commit, rootGetters }, donorCompanyId) {
    try {
      commit('SET_DONOR_DONATIONS_LOADING', true);
      commit('SET_DONOR_DONATIONS_ERROR', null);

      const queryParams = {
        donor_company_id: donorCompanyId
      };

      const response = await request(
        'GET',
        'api/donations-dashboard/donations-by-donor',
        rootGetters['auth/getToken'],
        {},
        queryParams
      );

      if (response.data && response.data.success) {
        commit('SET_DONOR_DONATIONS_DATA', response.data.data);
      } else {
        throw new Error('Failed to fetch donor donations data');
      }
    } catch (error) {
      console.error('Error fetching donor donations data:', error);
      commit('SET_DONOR_DONATIONS_ERROR', error.message || 'Failed to fetch donor donations data');
      throw error;
    } finally {
      commit('SET_DONOR_DONATIONS_LOADING', false);
    }
  },

  async fetchVolunteersData({ commit, rootGetters }) {
    try {
      commit('SET_VOLUNTEERS_LOADING', true);
      commit('SET_VOLUNTEERS_ERROR', null);

      const response = await request(
        'GET',
        'api/donations-dashboard/volunteers-breakdown',
        rootGetters['auth/getToken'],
        {},
        {}
      );

      if (response.data && response.data.success) {
        commit('SET_VOLUNTEERS_DATA', response.data.data);
      } else {
        throw new Error('Failed to fetch volunteers data');
      }
    } catch (error) {
      console.error('Error fetching volunteers data:', error);
      commit('SET_VOLUNTEERS_ERROR', error.message || 'Failed to fetch volunteers data');
      throw error;
    } finally {
      commit('SET_VOLUNTEERS_LOADING', false);
    }
  },

  async fetchMarketplaceLocationsData({ commit, rootGetters }) {
    try {
      commit('SET_MARKETPLACE_LOCATIONS_LOADING', true);
      commit('SET_MARKETPLACE_LOCATIONS_ERROR', null);

      const response = await request(
        'GET',
        'api/donations-dashboard/marketplace-locations-breakdown',
        rootGetters['auth/getToken'],
        {},
        {}
      );

      if (response.data && response.data.success) {
        commit('SET_MARKETPLACE_LOCATIONS_DATA', response.data.data);
      } else {
        throw new Error('Failed to fetch marketplace locations data');
      }
    } catch (error) {
      console.error('Error fetching marketplace locations data:', error);
      commit('SET_MARKETPLACE_LOCATIONS_ERROR', error.message || 'Failed to fetch marketplace locations data');
      throw error;
    } finally {
      commit('SET_MARKETPLACE_LOCATIONS_LOADING', false);
    }
  },
};

const state = {
  environmentalImpactData: null,
  environmentalImpactLoading: false,
  environmentalImpactError: null,
  donationTagsBreakdownData: null,
  donationTagsBreakdownLoading: false,
  donationTagsBreakdownError: null,
  donationMetricsData: null,
  donationMetricsLoading: false,
  donationMetricsError: null,
  donationsFeedData: null,
  donationsFeedLoading: false,
  donationsFeedError: null,
  topDonorsData: null,
  topDonorsLoading: false,
  topDonorsError: null,
  companiesData: null,
  companiesLoading: false,
  companiesError: null,
  donorDonationsData: null,
  donorDonationsLoading: false,
  donorDonationsError: null,
  volunteersData: null,
  volunteersLoading: false,
  volunteersError: null,
  marketplaceLocationsData: null,
  marketplaceLocationsLoading: false,
  marketplaceLocationsError: null,

};

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state,
};